import { useEffect } from 'react';
import { api } from '@shared/api';

/** События продукта в нашем журнале (`POST /events`, решение владельца 2026-10-21): заходы и открытия страниц,
 *  которые база иначе не видит. Первая сторона — блокировщики не режут, всё связано с учеником; идут в аналитику
 *  админки. Ответ не ждём, ошибка не мешает ученику. */
export type ProductEvent = 'app_open' | 'plans_opened' | 'topics_opened' | 'stories_opened';

export function logProductEvent(name: ProductEvent): void {
  void api.post('/events', { name }).catch(() => undefined);
}

/** Заход в приложение — один раз на загрузку страницы и ученика. */
let openedFor: string | null = null;
export function logAppOpen(userId: string | null | undefined): void {
  if (!userId || openedFor === userId) return;
  openedFor = userId;
  logProductEvent('app_open');
}

/** Открытие страницы вошедшим учеником — один раз на её монтирование. */
export function useProductEventOnMount(name: ProductEvent, enabled = true): void {
  useEffect(() => {
    if (enabled) logProductEvent(name);
  }, [name, enabled]);
}
